import React, { PropsWithChildren, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { CssBaseline, ThemeProvider } from '@mui/material'

import { Fbq, Gtag, Rdt, Ttq, UserEventsProvider } from '@xylabs/react-pixel'
import { PixelApi, XyPixel } from '@xylabs/pixel'

import { log } from 'app-logic/logging/log'
import { Iterable, UserEvents } from './business-logic/tracking'
import { AppRoutes } from './AppRoutes'
import { themeOptions } from './design-system/themeOptions'
import { CookieBar } from './components'
import { AddressProvider, CartProvider, ContactProvider, PaymentProvider } from './business-logic/cart/context'
import { BrowserRouter } from 'react-router-dom'

const checkIFrame = () => {
  if (window.self !== window.top) {
    log.warn('checkIFrame', {
      location: window.top?.location?.href ?? 'Unknown',
    })
    return true
  }
  return false
}

const initXyPixel = () => {
  switch (document.location.hostname) {
    case 'localhost':
      XyPixel.selectApi(new PixelApi('local'))
      Iterable.selectApi('local')
      break
    case 'beta.coinapp.co':
      XyPixel.selectApi(new PixelApi('beta'))
      Iterable.selectApi('beta')
      break
    default:
      XyPixel.selectApi(new PixelApi('prod'))
      Iterable.selectApi('prod')
      break
  }
  XyPixel.init(document.location.hostname)
  localStorage.setItem('search', window.location.search)
}
const initPixels = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const global = window as any
  try {
    initXyPixel()
    Fbq.init('339003476728548')
    Gtag.init('G-TCJLRQCJ2H', 'AW-989965544', ['coinapp.co', 'localhost', 'localhost:3000'])
    if (global.pixels.tiktok) {
      Ttq.init('CBC6ISRC77U9C04LJ2KG')
    }
    if (global.pixels.reddit) {
      Rdt.init('t2_3qsbqscf')
    }
  } catch (ex) {
    log.error(`initPixels: ${ex}`)
  }
}

function App() {
  useEffect(() => {
    if (checkIFrame()) {
      setTimeout(() => {
        if (window.top) {
          window.top.location.replace(window.self.location.href)
        }
      }, 500)
    }

    initPixels()
  }, [])
  /*
     TODO - theme provider may be a bit redundant here, its in the base page with is prob ideal,
     so each page can theme itself without having to battle styles
   */
  return (
    <BrowserRouter>
      <UserEventsProvider userEvents={UserEvents.get()}>
        <CheckoutProviders>
          <Helmet>
            <meta charSet="utf-8" />
            <title>COIN: Always Earning</title>
            <meta content="index, follow" name="robots" />
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-TCJLRQCJ2H" />
            <script async src="https://connect.facebook.net/en_US/fbevents.js" />
          </Helmet>
          <CssBaseline />
          <ThemeProvider theme={ themeOptions }>
            <AppRoutes />
          </ThemeProvider>
          <CookieBar />
        </CheckoutProviders>
      </UserEventsProvider>
    </BrowserRouter>
  )
}
//TODO - move to page specific
const CheckoutProviders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <CartProvider>
      <ContactProvider>
        <AddressProvider>
          <PaymentProvider>
            {children}
          </PaymentProvider>
        </AddressProvider>
      </ContactProvider>
    </CartProvider>
  )
}

export default App
